/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, GetLeadsGroupBy, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useTranslation } from 'react-i18next';
import { TranslationTextList } from '../../locales/common';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import PeopleOutlinedIcon from '@material-ui/icons/PeopleOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
    }),
);

export enum SalesPipelineOptionEnum {
    ESTIMATED_FEES = 0,
    PIPELINE,
}
interface SalesPipelineChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    groupBy: 'AreaOfLaw' | 'Assignee' | 'Location';
}

interface ChartState {
    symbol: string;
    options: SalesPipelineOptionEnum;

    enquiryCount: number[];
    value: number[];
    groupedBy: string[];
    openEnquiryCount: number;
    totalValue: number;
}

export const SalesPipelineChart: React.FC<SalesPipelineChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    const { t } = useTranslation() as {
        t: (key: keyof TranslationTextList) => string;
    };

    // tslint:disable-next-line:no-any
    const salesPipelineQuery = useQuery<SalesPipelineData>(SALES_PIPEPLINE_QUERY, {
        variables: {
            groupBy: props.groupBy,
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            // responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'cache-and-network',
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    const [state, setState] = useState<ChartState>({
        symbol: '$',
        enquiryCount: [],
        value: [],
        groupedBy: [],
        openEnquiryCount: 0,
        totalValue: 0,
        options: SalesPipelineOptionEnum.ESTIMATED_FEES,
    });

    useEffect(() => {
        // tslint:disable-next-line: max-line-length
        if (
            salesPipelineQuery.data &&
            salesPipelineQuery.data.statistics &&
            salesPipelineQuery.data.statistics.lead &&
            salesPipelineQuery.data.statistics.lead.salesPipelines &&
            !salesPipelineQuery.loading &&
            !salesPipelineQuery.error
        ) {
            const { groupedSalesPipeline, openEnquiryCount, groupedSalesPipelineEstimatedFees } = salesPipelineQuery.data.statistics.lead.salesPipelines;

            let enquiryCount: number[] = [];
            let value: number[] = [];
            let groupedBy: string[] = [];
            let totalValue: number = 0;

            if (state.options === SalesPipelineOptionEnum.ESTIMATED_FEES) {
                enquiryCount = groupedSalesPipelineEstimatedFees.groupedSalesPipelines.map(
                    (groupedSalesPipelines: GroupedSalesPipelineElement) => groupedSalesPipelines.enquiryCount,
                );
                value = groupedSalesPipelineEstimatedFees.groupedSalesPipelines.map((groupedSalesPipelines: GroupedSalesPipelineElement) => groupedSalesPipelines.value);
                groupedBy = groupedSalesPipelineEstimatedFees.groupedSalesPipelines.map((groupedSalesPipelines: GroupedSalesPipelineElement) => groupedSalesPipelines.groupedBy);
                totalValue = groupedSalesPipelineEstimatedFees.totalValue;
            } else {
                enquiryCount = groupedSalesPipeline.groupedSalesPipelines.map((groupedSalesPipelines: GroupedSalesPipelineElement) => groupedSalesPipelines.enquiryCount);
                value = groupedSalesPipeline.groupedSalesPipelines.map((groupedSalesPipelines: GroupedSalesPipelineElement) => groupedSalesPipelines.value);
                groupedBy = groupedSalesPipeline.groupedSalesPipelines.map((groupedSalesPipelines: GroupedSalesPipelineElement) => groupedSalesPipelines.groupedBy);
                totalValue = groupedSalesPipeline.totalValue;
            }

            setState((prevState) => {
                return {
                    ...prevState,
                    enquiryCount,
                    value,
                    groupedBy,
                    openEnquiryCount,
                    totalValue,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [state.options, salesPipelineQuery.loading, salesPipelineQuery.error, salesPipelineQuery.data]);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isSalesPipelineBy${props.groupBy}ChartOpen`);
        }
    };

    const handleTotalClick = () => {
        // if (props.getSelectedItem) {
        //     const searchCriterias = new Array<SearchCriteria>();
        //     searchCriterias.push(
        //         {property: 'MatterInvoiceDates', operator: 'gt', comparison: '0'}
        //     );
        //     props.getSelectedItem(
        //         searchCriterias,
        //         true,
        //         `WIP Lockup Days by ${GetGroupBy(props.groupBy)}`,
        //         DrillDownType.matterSummaryDrilldown,
        //         'Unbilled Fees'
        //     );
        // }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                options: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    if (salesPipelineQuery.loading || currencySymbolQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.value) ? ' rv-chart--empty' : ''}`}>
            <IconButtonWrapper aria-label="close">
                <ChartInfo 
                    description={props.description}
                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                    className={`${classes.helpIcon} rv-chart-help`}
                />
                <IconButton aria-label="close" onClick={onCloseChart} size="small">
                    <CloseIcon className={classes.closeIcon} />
                </IconButton>
            </IconButtonWrapper>
            <div className={classes.titleContainer}>
                <ChartHeading icon={<PeopleOutlinedIcon />} title="Sales Pipeline" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.totalValue} format={(amount) => `${state.symbol}${formatNumber(amount)}`} />
                </div>
                <div className={classes.title}>By {GetLeadsGroupBy(props.groupBy)}</div>
            </div>
            <div className={classes.barContainer}>
                <Bar
                    ref={chartRef}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            // const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            // const item = state.groupedBy[_index];

                            // const searchCriterias = new Array<SearchCriteria>();
                            // searchCriterias.push(
                            //     {
                            //         property: props.groupBy,
                            //         operator: 'eq',
                            //         comparison: item
                            //     },
                            //     {
                            //         property: 'MatterInvoiceDates',
                            //         operator: 'eq',
                            //         comparison: '0'
                            //     }
                            // );
                            // props.getSelectedItem(
                            //     searchCriterias,
                            //     true,
                            //     `WIP Lockup Days by ${GetGroupBy(props.groupBy)}`,
                            //     DrillDownType.matterSummaryDrilldown,
                            //     'Unbilled Fees'
                            // );
                        }
                    }}
                    data={{
                        labels: getLabels(state.groupedBy),
                        datasets: [
                            {
                                label: state.options === SalesPipelineOptionEnum.ESTIMATED_FEES ? 'Estimated Fees' : 'Pipeline',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary, true),
                                data: state.value,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                stacked: true,
                                suggestedMax: getSuggestedMaxTick(state.value),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.value),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${state.symbol}${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                stacked: true,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                }
                                // min: 0,
                                // max: 9 // minimum display
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: false,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: false,
                                    },
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return `${dataset.label}: ${state.symbol}${formatNumber(currentValue)}`;
                                    },
                                    // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {

                                        const {
                                              dataIndex,
                                            //   label,
                                            // formattedValue,
                                            // dataset,
                                        } = context;

                                        // const amount = state.amount[tooltipItem.index];
                                        const enquiry = state.enquiryCount[dataIndex];

                                        return [
                                            `${t('Enquiries')}: ${formatNumber(enquiry)}`,
                                        ];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.value) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div">
                <RadioGroup name="last" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={SalesPipelineOptionEnum.ESTIMATED_FEES} control={<Radio color="primary" />} label="Estimated Fees" />
                    <FormControlLabel value={SalesPipelineOptionEnum.PIPELINE} control={<Radio color="primary" />} label="Pipeline" />
                </RadioGroup>
            </FormControl>
            <span className={classes.span}>{formatNumber(state.openEnquiryCount)} open {t('enquiries')} have no Fee Estimate</span>
            {/* <span className={classes.span}>Drill down to timekeeper details</span>     
            <span className={classes.span}>The top 10 timekeepers are shown</span>                           */}
        </div>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

export interface SalesPipelineData {
    statistics: Statistics;
}

export interface Statistics {
    lead: Lead;
}

export interface Lead {
    salesPipelines: SalesPipelines;
}

export interface SalesPipelines {
    openEnquiryCount: number;
    groupedSalesPipeline: GroupedSalesPipeline;
    groupedSalesPipelineEstimatedFees: GroupedSalesPipeline;
}

export interface GroupedSalesPipeline {
    totalValue: number;
    groupedSalesPipelines: GroupedSalesPipelineElement[];
}

export interface GroupedSalesPipelineElement {
    enquiryCount: number;
    groupedBy: string;
    value: number;
}

const SALES_PIPEPLINE_QUERY = gql`
    # Write your query or mutation here
    query salesPipeline($groupBy: NewLeadsGroupBy, $entityType: Int, $entityGuid: String) {
        statistics {
            lead {
                salesPipelines(groupBy: $groupBy, entityType: $entityType, entityGuid: $entityGuid) {
                    openEnquiryCount
                    groupedSalesPipeline {
                        totalValue
                        groupedSalesPipelines {
                            enquiryCount
                            groupedBy
                            value
                        }
                    }
                    groupedSalesPipelineEstimatedFees {
                        totalValue
                        groupedSalesPipelines {
                            enquiryCount
                            groupedBy
                            value
                        }
                    }
                }
            }
        }
    }
`;
